import Actions from '../actions/actions';
import { handleActions } from 'redux-actions';
import { FacebookState } from '../interfaces/facebook';
import facebookSDKActions from '../actions/facebookActions';

const ACTIONS = facebookSDKActions.ACTIONS;

const initialState: FacebookState = {
  isInitialized: false,
  customerChatLoaded: false,
};

const initializeFacebookSDK = (state: FacebookState): FacebookState => ({
  ...state,
  isInitialized: true,
});

const setCustomerChatLoaded = (state: FacebookState): FacebookState => ({
  ...state,
  customerChatLoaded: true,
});

const reset = (): FacebookState => initialState;

const mappedReducers = {
  [ACTIONS.SET_IS_INITIALIZED]: initializeFacebookSDK,
  [ACTIONS.SET_CUSTOMER_CHAT_LOADED]: setCustomerChatLoaded,
  [Actions.RESET]: reset,
};

const facebook = handleActions(mappedReducers, initialState);

export default facebook;
